import { render, staticRenderFns } from "./ListadoCostosProgramas.vue?vue&type=template&id=65c26623"
import script from "./ListadoCostosProgramas.vue?vue&type=script&lang=js"
export * from "./ListadoCostosProgramas.vue?vue&type=script&lang=js"
import style0 from "./ListadoCostosProgramas.vue?vue&type=style&index=0&id=65c26623&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports